// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a9eda40f","455":"bcab1705","829":"492a666b"}[chunkId] + ".chunk.js";
};